(() => {
  function cleanTextNodeMarkers(root = document) {
    const selectors = [
      'nav[aria-label*="breadcrumb" i] a',
      'nav[aria-label*="breadcrumb" i] span',
      '.breadcrumb a',
      '.breadcrumb span',
      '.breadcrumbs a',
      '.breadcrumbs span',
      '.breadcrumb__link',
      '.breadcrumb__item',
      '[class*="breadcrumb"] a',
      '[class*="breadcrumb"] span'
    ];

    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(selectors.join(',')).forEach((el) => {
      if (el.children.length > 0) return;
      if (el.textContent && el.textContent.includes('|')) {
        el.textContent = el.textContent.replace(/\|/g, '');
      }
    });
  }

  function cleanDocumentTitle() {
    if (document.title && document.title.includes('|')) {
      document.title = document.title.replace(/\|/g, '');
    }

    document.querySelectorAll('meta[property="og:title"], meta[name="twitter:title"]').forEach((meta) => {
      const content = meta.getAttribute('content');
      if (content && content.includes('|')) {
        meta.setAttribute('content', content.replace(/\|/g, ''));
      }
    });
  }

  function run(root = document) {
    cleanDocumentTitle();
    cleanTextNodeMarkers(root);
  }

  function boot() {
    run();
    setTimeout(run, 250);
    setTimeout(run, 800);
    setTimeout(run, 1600);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) run(node);
        });
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => run(event.target));
})();
